/*
 * The LoginModule holds functionality of client login.
 */

// Modules
import { ComponentsModule } from '@components/components.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { IvyCarouselModule } from '@components/ivy-carousel/carousel.module';
import { NgModule } from '@angular/core';
import { PipesModule } from '@pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
// Componnents
import { HomePage } from './home.page';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ActivitiesComponent } from './components/activities/activities.component';
import { DestinationsComponent } from './components/destinations/destinations.component';
import { PackagesComponent } from './components/packages/packages.component';
import { PartnersComponent } from './components/partners/partners.component';
import { SliderComponent } from './components/slider/slider.component';
import { SupportersComponent } from './components/supporters/supporters.component';
import { TrustBoxComponent } from './components/trustbox/trustbox.component';
import { WhyBytComponent } from './components/why-byt/why-byt.component';
// Pipes
import { GetImageUrlDirectus } from '@pipes/get-image-url-direcuts/get-image-url-directus.pipe';

@NgModule({
  declarations: [
    HomePage,
    // Componnents
    AboutUsComponent,
    ActivitiesComponent,
    DestinationsComponent,
    PackagesComponent,
    PartnersComponent,
    SliderComponent,
    SupportersComponent,
    TrustBoxComponent,
    WhyBytComponent
  ],
  imports: [
    ComponentsModule,
    DirectivesModule,
    IvyCarouselModule,
    LazyLoadImageModule,
    RouterModule.forChild([
      {
        path: '',
        component: HomePage
      }
    ]),
    PipesModule
  ],
  providers: [GetImageUrlDirectus]
})
export class HomePageModule {}
